import {
  LOG_OUT,
  UPDATE_AUTH_TOKEN,
  UPDATE_EMAIL_ADDRESS,
  UPDATE_REFRESH_TOKEN,
  UPDATE_UUID
} from '../../constants'
import { PayloadAction } from '@reduxjs/toolkit'
import { Auth } from '../../../../../common/interfaces/Auth'

export const updateEmailAddress = (email: string): PayloadAction<any> => {
  return {
    type: UPDATE_EMAIL_ADDRESS,
    payload: {
      email
    }
  }
}

export const updateUUID = (id: string): PayloadAction<any> => {
  return {
    type: UPDATE_UUID,
    payload: {
      id
    }
  }
}

export const updateAuthToken = (auth: Auth): PayloadAction<any> => {
  return {
    type: UPDATE_AUTH_TOKEN,
    payload: {
      auth
    }
  }
}

export const logout = (): PayloadAction<any> => {
  return {
    type: LOG_OUT,
    payload: {}
  }
}
export const updateRefreshToken = (token: string): PayloadAction<any> => {
  return {
    type: UPDATE_REFRESH_TOKEN,
    payload: {
      token
    }
  }
}
